import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { ICellRendererAngularComp } from 'ag-grid-angular';
import type { ICellRendererParams } from 'ag-grid-community';
import { IconoirPlusSquare, IconoirMinusSquare } from '@ey-xd/motif-icon';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';

/**
 * ExpandMenuComponent is an Angular standalone component designed as a custom cell renderer for ag-Grid tables.
 * It provides expand and collapse functionality within a grid cell, displaying appropriate icons for each state.
 * The component integrates Motif button and icon modules for consistent UI, and is intended for use in deliverables tables
 * where row expansion or collapse is required.
 *
 * Implements ICellRendererAngularComp for ag-Grid integration.
 * Accepts ag-Grid cell renderer parameters to manage expand/collapse state and actions.
 */
@Component({
  selector: 'app-expand-menu',
  standalone: true,
  imports: [CommonModule, MotifIconModule, MotifButtonModule],
  templateUrl: './expand-menu.component.html',
  styleUrl: './expand-menu.component.scss',
})
export class ExpandMenuComponent implements ICellRendererAngularComp {
  public params: any;
  public expandIcon = IconoirPlusSquare;
  public collapseIcon = IconoirMinusSquare;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams) {
    this.params = params;
    return true;
  }

  onExpandClick(): void {
    if (this.params?.context?.componentParent?.onExpandIconClick) {
      this.params.context.componentParent.onExpandIconClick(this.params.data);
    }
  }
}
